export default __webpack_public_path__ + "static/media/5ff05d9508c16725.e552aa3ee594b1a96b3c856e518c8bb2.svg";